/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestimonialContent } from '../../models/testimonial-content';

export interface ApiMasterTestimonialContentGetActiveGet$Params {
}

export function apiMasterTestimonialContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterTestimonialContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TestimonialContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTestimonialContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TestimonialContent>>;
    })
  );
}

apiMasterTestimonialContentGetActiveGet.PATH = '/api/Master/TestimonialContent/GetActive';
